import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';

export async function getAccessToken(
  instance: IPublicClientApplication,
  account: AccountInfo,
  request: { scopes: string[] }
): Promise<string> {
  const { accessToken } = await instance.acquireTokenSilent({
    ...request,
    account
  });
  return accessToken;
}
